<template>
  <div
    v-if="isNoti"
    class="noti p-2 d-flex align-items-start"
    :class="[dynamicNotiTypeClass, dynamicNotiVariantClass, isInline ? 'align-items-center' : 'align-items-start']"
  >
    <div v-if="variant === 'sticky'" class="sticky-decorator" :class="dynamicDecortorClass"></div>
    <i class="icon pr-1" :class="[dynamicIconClass, {'icon__none-inline': !isInline}]"></i>
    <div class="d-flex justify-content-between flex-grow-1" :class="isInline ? 'align-items-center' : 'align-items-start'">
      <div
        class="d-flex flex-grow-1 justify-content-between noti__content"
        :class="isInline ? 'align-items-center' : !isInlineAction && 'flex-column'"
      >
        <p
          class="noti__content-desc paragraph-14-regular text-lightmode"
          :class="{ 'noti__content-desc--info': type == 'infor' }"
          v-if="htmlDesc"
          v-html="htmlDesc"
          @click="triggerClickEvent"
        >
        </p>
        <p
          class="noti__content-desc paragraph-14-regular text-lightmode"
          :class="{ 'noti__content-desc--info': type == 'infor' }"
          v-else
        >
          <slot name="description"></slot>
        </p>
        <p
          v-if="actionTitle"
          class="noti__content-action paragraph-12-medium"
          :class="isInlineAction && 'noti__content-action-inline'"
          @click="triggerAction"
        >
          {{ actionTitle }}
        </p>
        <a
          v-if="contentLinkTitle"
          class="noti__content-link paragraph-12-medium"
          :class="{ 'mt-1': !isInline }"
          :href="contentLink"
          target="_blank"
          >{{ contentLinkTitle }}</a
        >
      </div>
      <div v-if="isClose" @click="close" class="noti__close-btn ml-2 clickable" :class="{'mt-half': !isInline}">
        <i class="icon icon-small-cancel text-dark6"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Noti",
  props: {
    type: String,
    variant: String,
    htmlDesc: String,
    contentLinkTitle: String,
    contentLink: String,
    isClose: Boolean,
    isInline: Boolean,
    isInlineAction: Boolean,
    isCloseOnAction: Boolean,
    actionTitle: String
  },
  data() {
    return {
      isNoti: true
    };
  },
  computed: {
    dynamicNotiTypeClass() {
      return this.dynamicTypeClass("noti");
    },
    dynamicDecortorClass() {
      return this.dynamicTypeClass("sticky-decorator");
    },
    dynamicNotiVariantClass() {
      switch (this.variant) {
        case "sticky":
          return "noti--sticky";
        default:
          return "noti--toast";
      }
    },
    dynamicIconClass() {
      switch (this.type) {
        case "warn":
          return "icon-warn-triangle";
        default:
          return "icon-infor-fill";
      }
    }
  },
  methods: {
    triggerAction() {
      if (this.isCloseOnAction) this.isNoti = false;
      this.$emit("action");
    },
    triggerClickEvent(e) {
      this.$emit("clickEvent", e);
    },
    close() {
      this.$emit("onClose");
      this.isNoti = false;
    },
    dynamicTypeClass(className) {
      switch (this.type) {
        case "infor":
          return `${className}--info`;
        default:
          return `${className}--warn`;
      }
    }
  }
};
</script>

<style lang="scss">
.noti {
  width: 100%;
  border-radius: 3px;
  min-height: 56px;

  .sticky-decorator {
    width: 2px;
    height: 100%;
    position: absolute;
    left: 0;
    &--info {
      background-color: $mono5;
    }
    &--warn {
      background-color: $accent-amber400;
    }
  }

  &--sticky {
    height: 54px;
    border-radius: 0px;
    .icon {
      font-size: 16px;
    }
  }

  &--toast {
    .icon {
      font-size: 20px;
    }
  }

  &--warn {
    background-color: $accent-amber200;
  }

  &--info {
    background-color: $cSecondary8;
  }

  .icon {
    &__none-inline {
      margin-top: 2px;
    }
    &-infor-fill {
      color: $mono5;
    }
    &-warn-triangle {
      color: $black3;
    }
    &-cancel {
      font-size: 16px;
      cursor: pointer;
    }
  }

  &__close-btn {
    width: 24px;
    height: 24px;
    display: flex;;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  &__content {
    &-link,
    &-action {
      cursor: pointer;
      color: $mono4;
      position: relative;
      width: fit-content;
      height: 24px;
      padding: 0 8px;
      @include flex-center;
      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 24px;
        border-radius: 3px;
        background-color: #000000;
        opacity: 0;
        @include trans-all;
      }
      &:hover::before {
        opacity: 0.1;
      }
      &-inline {
        flex: none;
        line-height: 24px !important;
        margin-left: 16px !important;
      }
    }
    &-desc {
      &--info {
        line-height: 24px;
        a {
          color: map-get($primary-blue, '300');
          &:hover {
            color: map-get($primary-blue, '325');
            text-decoration: underline;
          }
        }
      }
    }
  }

}
</style>
